import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { AbsoluteTooltipModule } from '../../../../shared/ui/absolute-tooltip/absolute-tooltip.module'
import { DirectivesUpgradedModule } from '../../../../shared/directives/directivesUpgraded.module'
import { CuzkLoginDialogComponent } from './cuzk-login-dialog.component'

@NgModule({
    declarations: [CuzkLoginDialogComponent],
    exports: [CuzkLoginDialogComponent],
    imports: [
        CommonModule,
        FormsModule,
        AbsoluteTooltipModule,
        DirectivesUpgradedModule,
    ],
})
export class CuzkLoginDialogModule {}
